enum GenerateFileContext {
    Print = 0,
    PreviewForSignatureOnPrint = 2,
    PreviewForSignatureOnFax = 3,
    PreviewPortalSync = 4
}

export { GenerateFileContext };
